/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [],
        name: "factory",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "fee",
        outputs: [
            {
                internalType: "uint24",
                name: "",
                type: "uint24",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "feeChargePercent",
        outputs: [
            {
                internalType: "uint24",
                name: "",
                type: "uint24",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "feeScaleX_128",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "feeScaleY_128",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "leftMostPt",
        outputs: [
            {
                internalType: "int24",
                name: "",
                type: "int24",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int24",
                name: "",
                type: "int24",
            },
        ],
        name: "limitOrderData",
        outputs: [
            {
                internalType: "uint128",
                name: "sellingX",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "earnY",
                type: "uint128",
            },
            {
                internalType: "uint256",
                name: "accEarnY",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "legacyAccEarnY",
                type: "uint256",
            },
            {
                internalType: "uint128",
                name: "legacyEarnY",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "sellingY",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "earnX",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "legacyEarnX",
                type: "uint128",
            },
            {
                internalType: "uint256",
                name: "accEarnX",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "legacyAccEarnX",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "liquidities",
        outputs: [
            {
                internalType: "uint128",
                name: "liquidity",
                type: "uint128",
            },
            {
                internalType: "uint256",
                name: "lastFeeScaleX_128",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "lastFeeScaleY_128",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "tokenOwedX",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "tokenOwedY",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "maxLiquidPt",
        outputs: [
            {
                internalType: "uint128",
                name: "",
                type: "uint128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "observations",
        outputs: [
            {
                internalType: "uint32",
                name: "timestamp",
                type: "uint32",
            },
            {
                internalType: "int56",
                name: "accPoint",
                type: "int56",
            },
            {
                internalType: "bool",
                name: "init",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int24",
                name: "",
                type: "int24",
            },
        ],
        name: "orderOrEndpoint",
        outputs: [
            {
                internalType: "int24",
                name: "",
                type: "int24",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int16",
                name: "",
                type: "int16",
            },
        ],
        name: "pointBitmap",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pointDelta",
        outputs: [
            {
                internalType: "int24",
                name: "",
                type: "int24",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int24",
                name: "",
                type: "int24",
            },
        ],
        name: "points",
        outputs: [
            {
                internalType: "uint128",
                name: "liquidSum",
                type: "uint128",
            },
            {
                internalType: "int128",
                name: "liquidDelta",
                type: "int128",
            },
            {
                internalType: "uint256",
                name: "accFeeXOut_128",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "accFeeYOut_128",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "isEndpt",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "rightMostPt",
        outputs: [
            {
                internalType: "int24",
                name: "",
                type: "int24",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "state",
        outputs: [
            {
                internalType: "uint160",
                name: "sqrtPrice_96",
                type: "uint160",
            },
            {
                internalType: "int24",
                name: "currentPoint",
                type: "int24",
            },
            {
                internalType: "uint16",
                name: "observationCurrentIndex",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "observationQueueLen",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "observationNextQueueLen",
                type: "uint16",
            },
            {
                internalType: "bool",
                name: "locked",
                type: "bool",
            },
            {
                internalType: "uint128",
                name: "liquidity",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "liquidityX",
                type: "uint128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint128",
                name: "amount",
                type: "uint128",
            },
            {
                internalType: "int24",
                name: "highPt",
                type: "int24",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "swapY2X",
        outputs: [
            {
                internalType: "uint256",
                name: "amountX",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amountY",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint128",
                name: "desireX",
                type: "uint128",
            },
            {
                internalType: "int24",
                name: "highPt",
                type: "int24",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "swapY2XDesireX",
        outputs: [
            {
                internalType: "uint256",
                name: "amountX",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amountY",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "tokenX",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "tokenY",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalFeeXCharged",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalFeeYCharged",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "userEarnX",
        outputs: [
            {
                internalType: "uint256",
                name: "lastAccEarn",
                type: "uint256",
            },
            {
                internalType: "uint128",
                name: "sellingRemain",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "sellingDec",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "earn",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "legacyEarn",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "earnAssign",
                type: "uint128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "userEarnY",
        outputs: [
            {
                internalType: "uint256",
                name: "lastAccEarn",
                type: "uint256",
            },
            {
                internalType: "uint128",
                name: "sellingRemain",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "sellingDec",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "earn",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "legacyEarn",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "earnAssign",
                type: "uint128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class SwapY2XModule__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
SwapY2XModule__factory.bytecode = _bytecode;
SwapY2XModule__factory.abi = _abi;
